import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Route from '../common/Route';
import SignUpConfirmRoute from './SignUpConfirmRoute';

const SignUpRoutes = () => {
  const intl = useIntl();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={`${path}/confirm`}
        title={intl.formatMessage({
          id: 'signUpComplete.seo.title',
          defaultMessage: 'ClearVPN | Completing sign up',
          description: 'SEO title of the page, where user’s account gets created by the link from email',
        })}
      >
        <SignUpConfirmRoute />
      </Route>
    </Switch>
  );
};

export default SignUpRoutes;
